import register from '../../../../global/js/registry';
export default register('a-play-button', () => import(/* webpackMode: "lazy" */ './a-play-button.controller'));
